import { Game, eAtlas_0 } from "../../Game";
import { DeliveryBonus as Model } from "../Parcel/DeliveryBonus";
import { ProgressBar, eProgressBarDir } from "../../Utils/UI Elements/ProgressBar";
import { TextureAtlasUtils } from "../../Utils/TextuAtlasUtils";
import { Gameplay } from "../Gameplay";
import { Player } from "../Player/Player";



export class DeliveryBonus {
    private _bar: ProgressBar;

    private _data: Model;
    private _prevBonusProgress: number;

    private _icon: pc.Entity;
    private _iconFrames: pc.Vec4[];

    private _multiplier: pc.Entity;
    private _multiplierFrames: pc.Vec4[];
    private _curPkgCnt: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(hud: pc.Entity, data: Model) {
        let atlas = Game.APP.assets.find(eAtlas_0.NAME, pc.eAssetType.atlas).resource as pc.TextureAtlas;

        this._data = data;

        this._bar = new ProgressBar(atlas, eAtlas_0.deliveryBnsBar, eAtlas_0.deliveryBnsBarFill, 4, 8, eProgressBarDir.horizontalR);
        this._bar.entity.setLocalPosition(60, -28, 0);
        hud.addChild(this._bar.entity);

        // Ikona
        this._iconFrames = [
            new pc.Vec4(),
            new pc.Vec4(),
        ];

        this._iconFrames[0].copy((<pc.TextureAtlasFrame>atlas.frames[eAtlas_0.deliveryBnsIcon_0]).rect);
        this._iconFrames[1].copy((<pc.TextureAtlasFrame>atlas.frames[eAtlas_0.deliveryBnsIcon_1]).rect);

        this._icon = new pc.Entity();
        this._icon.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: this._iconFrames[0].z,
            height: this._iconFrames[0].w,
            anchor: [0, 1, 0, 1],
            pivot: [0, 1]
        });

        this._iconFrames.forEach((rect: pc.Vec4) => { TextureAtlasUtils.getTexFrameRegion(atlas.texture, rect, rect); });
        this._icon.setLocalPosition(20, -20, 0);
        hud.addChild(this._icon);

        // Nasobice
        this._multiplierFrames = [];

        for (let i = 0; i < 9; i++) {
            let rc = new pc.Vec4();

            rc.copy((<pc.TextureAtlasFrame>atlas.frames["x" + (i + 1)]).rect);
            this._multiplierFrames.push(rc);
        }

        this._multiplier = new pc.Entity();
        this._multiplier.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            width: this._multiplierFrames[0].z,
            height: this._multiplierFrames[0].w,
            anchor: [0, 1, 0, 1],
            pivot: [0, 1]
        });

        this._multiplierFrames.forEach((rect: pc.Vec4) => { TextureAtlasUtils.getTexFrameRegion(atlas.texture, rect, rect); });
        this._multiplier.setLocalPosition(216, -28, 0);
        hud.addChild(this._multiplier);

        // Sledovat zmenu poctu nesenych balicku
        Gameplay.instance.events.on(Player.EVENT_PARCEL_CNT_CHANGE, this.handleParcelCntChange, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this.updateBar(0);
        this._multiplier.element.enabled = false;
        this._icon.element.rect = this._iconFrames[0];
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let i = this._data.bonusRatio;

        if (i != this._prevBonusProgress)
            this.updateBar(i);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateBar(progress: number): void {
        this._bar.state = progress;
        this._prevBonusProgress = progress;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleParcelCntChange(parcentTotCnt: number): void {
        if (parcentTotCnt != 0) {
            this._multiplier.element.rect = this._multiplierFrames[parcentTotCnt - 1];

            if (!this._multiplier.element.enabled) {
                this._icon.element.rect = this._iconFrames[1];
                this._multiplier.element.enabled = true;
            }
        }
        else {
            this.reset();
        }
    }
}